import { FC } from 'react';

import DirectDebitAdd from 'components/direct-debit-add';

const DirectDebitPay: FC = () => <DirectDebitAdd />;

export default DirectDebitPay;
